import { Loader } from 'lucide-react';
import { createIcon } from './createAntdIcon';

export const LoaderIcon = createIcon(Loader);

export default LoaderIcon;
